export const apiUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "http://0.0.0.0:8000";
export const feedListWidth = 300;
export const editPanelWidth = 500;
export const pageLength = 30;
export const appBarHeight = 64;
